import React from "react";
import LML from "../../assets/Home/Marquee/LML.webp";
import SEG from "../../assets/Home/Marquee/SEG.webp";
import ISK from "../../assets/Home/Marquee/ISK.webp";
import Staidrich from "../../assets/Home/Marquee/Staidrich.webp";
import Engginno from "../../assets/Home/Marquee/Engginno.webp";
import EParivahan from "../../assets/Home/Marquee/e parivahan.webp";
import Micronix from "../../assets/Home/Marquee/Micronix.webp";
import OBEN from "../../assets/Home/Marquee/OBEN.webp";
import Ampere from "../../assets/Home/Marquee/Ampere.webp";
import SPREMFI from "../../assets/Home/Marquee/SPREMFI.webp";
import Sora from "../../assets/Home/Marquee/Sora.webp";
import Hygg from "../../assets/Home/Marquee/hygg logo.webp";
import Sindhur from "../../assets/Home/Marquee/Sindhur.webp";

function Marquee() {
  return (
    <div className="p-logos-container">
      <div className="p-logos">
        <img src={LML} alt="LML logo" />
        <img src={SEG} alt="SEG logo" />
        <img src={ISK} alt="ISK logo" />
        <img src={Staidrich} alt="Staidrich logo" />
        <img src={Engginno} alt="Engginno logo" />
        <img src={EParivahan} alt="E Parivahan logo" />
        <img src={Micronix} alt="Micronix logo" />
        <img src={OBEN} alt="OBEN logo" />
        <img src={Ampere} alt="Ampere logo" />
        <img src={SPREMFI} alt="SPREMFI logo" />
        <img src={Sora} alt="Sora logo" />
        <img src={Hygg} alt="Hygg logo" />
        <img src={Sindhur} alt="Sindhur logo" />
        <img src={LML} alt="LML logo" />
        <img src={SEG} alt="SEG logo" />
        <img src={ISK} alt="ISK logo" />
        <img src={Staidrich} alt="Staidrich logo" />
        <img src={Engginno} alt="Engginno logo" />
        <img src={EParivahan} alt="E Parivahan logo" />
        <img src={Micronix} alt="Micronix logo" />
        <img src={OBEN} alt="OBEN logo" />
        <img src={Ampere} alt="Ampere logo" />
        <img src={SPREMFI} alt="SPREMFI logo" />
        <img src={Sora} alt="Sora logo" />
        <img src={Hygg} alt="Hygg logo" />
        <img src={Sindhur} alt="Sindhur logo" />
        <img src={LML} alt="LML logo" />
        <img src={SEG} alt="SEG logo" />
        <img src={ISK} alt="ISK logo" />
        <img src={Staidrich} alt="Staidrich logo" />
        <img src={Engginno} alt="Engginno logo" />
        <img src={EParivahan} alt="E Parivahan logo" />
        <img src={Micronix} alt="Micronix logo" />
        <img src={OBEN} alt="OBEN logo" />
        <img src={Ampere} alt="Ampere logo" />
        <img src={SPREMFI} alt="SPREMFI logo" />
        <img src={Sora} alt="Sora logo" />
        <img src={Hygg} alt="Hygg logo" />
        <img src={Sindhur} alt="Sindhur logo" />
        <img src={LML} alt="LML logo" />
        <img src={SEG} alt="SEG logo" />
        <img src={ISK} alt="ISK logo" />
        <img src={Staidrich} alt="Staidrich logo" />
        <img src={Engginno} alt="Engginno logo" />
        <img src={EParivahan} alt="E Parivahan logo" />
        <img src={Micronix} alt="Micronix logo" />
        <img src={OBEN} alt="OBEN logo" />
        <img src={Ampere} alt="Ampere logo" />
        <img src={SPREMFI} alt="SPREMFI logo" />
        <img src={Sora} alt="Sora logo" />
        <img src={Hygg} alt="Hygg logo" />
        <img src={Sindhur} alt="Sindhur logo" />
      </div>
    </div>
  );
}

export default Marquee;
